// React
import React, { useState, useEffect } from 'react';

// Prop types
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { withRoomContext } from '../../../RoomContext';

// Mui styles
import { withStyles } from '@material-ui/core/styles';

// Mui core
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';

// Icon
import PersonIcon from '@material-ui/icons/Person';

// Component
import SerivceName from './SerivceName';

// Constants
import {
	CALL_STATUS_SKIP
} from '../../../const';

// dayjs
import dayjs from 'dayjs';

const styles = () =>
	({
		root : {
			width           : '100%',
			height          : 'calc(100% - 100px)',
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			borderRadius    : '20px',
			backgroundColor : '#e5e5e2',
			padding         : '1%'
		},
		header : {
			display    : 'flex',
			position   : 'relative',
			alignItems : 'center'
		},
		wrapper : {
			width           : '100%',
			height          : 'calc(100% - 6.5rem)',
			backgroundColor : 'white',
			borderRadius    : '5px',
			boxShadow       : '3px 3px 10px #aaa',
			padding         : '3%',
			position        : 'relative'
		},
		tableBg : {
			display       : 'flex',
			position      : 'absolute',
			height        : '100%',
			width         : '100%',
			zIndex        : '0',
			pointerEvents : 'none',
			paddingRight  : 'calc(6% + 17px)',
			paddingBottom : '6%'
		},
		tableBgLine : {
			height      : '100%',
			borderRight : '1px solid #ccc'
		},
		tableHeader : {
			display : 'flex'
		},
		tableHeaderText : {
			fontSize      : '0.8rem',
			textAlign     : 'center',
			paddingBottom : '1.5rem',
			color         : '#999898'
		},
		tableData : {
			display      : 'flex',
			listStyle    : 'none',
			marginBottom : '0.8rem',
			position     : 'relative'
		},
		historyNo : {
			width : '6%'
		},
		historyNoTitle : {
			width : '10%'
		},
		historyNoData :
		{
			border       : 'none',
			borderRadius : '0.5rem',
			background   : '#999898',
			padding      : '5px',
			color        : 'white',
			textAlign    : 'center'
		},
		tableDataValues : {
			display      : 'flex',
			border       : 'none',
			borderRadius : '0.5rem',
			background   : 'rgba(0,0,0,0.1)',
			alignItems   : 'center',
			marginLeft   : '7%',
			zIndex       : 1,
			height       : '100%'
		},
		tableDataValue : {
			color     : '#888',
			textAlign : 'center',
			fontSize  : '0.8rem'
		},
		historyDate : {
			width : '20%'
		},
		historyDateContent : {
			width      : '20%',
			marginLeft : '1.7%'
		},
		historyTime : {
			width      : '20%',
			marginLeft : '1.5%',
			textAlign  : 'center'
		},
		historyContact : {
			width : '25%'
		},
		historyEmailTitle : {
			width  : '30%',
			border : 'none'
		},
		historyEmail : {
			width          : '30%',
			border         : 'none',
			justifyContent : 'center',
			display        : 'flex'
		},
		titleText : {
			fontSize : '0.8rem'
		},
		absentText : {
			width           : '12%',
			margin          : '0 auto',
			textAlign       : 'center',
			backgroundColor : '#888',
			color           : '#fff',
			padding         : '1%',
			borderRadius    : '0.5rem'
		},
		scrollBar : {
			overflow               : 'auto',
			height                 : '100%',
			paddingRight           : '10px',
			'&::-webkit-scrollbar' :
			{
				background   : '#ccc',
				width        : '7px',
				borderRadius : '100px'
			},
			'&::-webkit-scrollbar-thumb' :
			{
				background   : '#888',
				borderRadius : '100px',
				'&:hover'    :
				{
					background : '#555'
				}
			}
		},
		osTitle : {
			fontSize     : '0.8rem',
			border       : 'none',
			borderRadius : '0.5rem',
			background   : '#999898',
			color        : 'white',
			textAlign    : 'center',
			minWidth     : '5rem',
			padding      : '0.3rem 0'
		},
		osContent : {
			fontSize    : '0.8rem',
			paddingLeft : '0.5rem'
		},
		title : {
			color          : '#878686',
			fontSize       : '1rem',
			display        : 'flex',
			alignItems     : 'center',
			justifyContent : 'center',
			marginBottom   : '1rem'
		},
		iconTitle : {
			width       : '2rem',
			height      : '2rem',
			marginRight : '0.5rem'
		}
	});

const CallHistory = ({
	classes,
	calls,
	user
}) =>
{
	const [ callList, setCallList ] = useState([]);

	const getDateString = (timestamp) =>
	{
		const date = timestamp ? new Date(timestamp) : new Date();
		const month = (`0${date.getMonth() + 1}`).slice(-2);
		const day = (`0${date.getDate()}`).slice(-2);
		const hour = (`0${date.getHours()}`).slice(-2);
		const min = (`0${date.getMinutes()}`).slice(-2);

		return `${date.getFullYear()}/${month}/${day} ${hour}:${min}`;
	};

	const getTalkTimeString = (duration) =>
	{
		const seconds = parseInt(duration);
		const min = (`${parseInt(seconds/60)}`);
		const sec = (`0${parseInt(seconds%60)}`).slice(-2);

		return `${min}分${sec}秒`;
	};

	useEffect(() =>
	{
		setCallList(calls);
	}, [ calls ]);

	const todayStartTimeStamp =
		dayjs()
			.startOf('day')
			.valueOf();

	// eslint-disable-next-line no-console
	console.log('MeInfo user:', user);

	return (
		<Box className={classes.root}>
			<Box className={classes.header}>
				<SerivceName />
			</Box>
			<Box className={classes.title}>
				<PersonIcon className={classes.iconTitle}/>
				<Typography>着信リスト</Typography>
			</Box>
			<Box className={classes.wrapper}>
				<Box className={classes.tableBg}>
					<Box className={`${classes.tableBgLine} ${classes.historyNoTitle}`} />
					<Box className={`${classes.tableBgLine} ${classes.historyDate}`} />
					<Box className={`${classes.tableBgLine} ${classes.historyTime}`} />
					<Box className={`${classes.tableBgLine} ${classes.historyContact}`} />
					<Box className={`${classes.tableBgLine} ${classes.historyEmail}`} />
				</Box>
				<Box className={`${classes.scrollBar}`}>
					<ul>
						<Box className={classes.tableHeader}>
							<Box className={`${classes.tableHeaderText} ${classes.historyNoTitle}`}/>
							<Box className={`${classes.tableHeaderText} ${classes.historyDate}`}>
								日　付
							</Box>
							<Box className={`${classes.tableHeaderText} ${classes.historyTime}`}>
								通話時間
							</Box>
							<Box className={`${classes.tableHeaderText} ${classes.historyContact}`}>
								<span>ゲスト入力1</span>
								{user.guestInputField1?.key ?
									<><br /><span>({user.guestInputField1.key})</span></>
									: null}
							</Box>
							<Box className={`${classes.tableHeaderText} ${classes.historyEmailTitle}`}>
								<span>ゲスト入力2</span>
								{user.guestInputField2?.key ?
									<><br /><span>({user.guestInputField2.key})</span></>
									: null}
							</Box>
						</Box>
						{callList.length < 1 ? (
							<Box>No items</Box>
						) : (
							callList.map((item, index) =>
								(<li className={classes.tableData} key={index}>

									<Box className={`${classes.historyNo}`}>
										<Box className={classes.historyNoData}>
											<Badge
												color='secondary'
												invisible={
													item.status !== CALL_STATUS_SKIP ||
												item.timestamp < todayStartTimeStamp
												}
												variant='dot'
												anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
												className={classes.noResponseBadge}
											>
												<PersonIcon fontSize='large'/>
											</Badge>
											<Typography className={classes.titleText}>{`0${index + 1}`}</Typography>

										</Box>
									</Box>

									<Box position='absolute' width='100%' height='100%'>
										<Box className={`${classes.tableDataValues}`}>
											<Box className={`${classes.tableDataValue} ${classes.historyDateContent}`}>{getDateString(item.timestamp)}</Box>
											{item.status === CALL_STATUS_SKIP ?
												<Box className={classes.absentText}>不在</Box>
												:
												<Box
													className={`${classes.tableDataValue} ${classes.historyTime}`}
												>
													{getTalkTimeString(item.duration)}
												</Box>
											}
											<Box className={`${classes.tableDataValue} ${classes.historyContact}`}>
												<Box display='flex' flexDirection='column'>
													<Typography className={classes.titleText}>
														{item.guestInput1?.value ? item.guestInput1?.value : ''}
													</Typography>
												</Box>
											</Box>
											<Box className={`${classes.tableDataValue} ${classes.historyEmail}`}>
												<Typography className={classes.titleText}>
													{item.guestInput2?.value ? item.guestInput2?.value : ''}</Typography>
											</Box>
										</Box>
									</Box>
								</li>)
							))}
					</ul>
				</Box>
			</Box>
		</Box>
	);

};

CallHistory.propTypes =
{
	classes : PropTypes.object.isRequired,
	calls   : PropTypes.array.isRequired,
	user    : PropTypes.object.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		calls : state.room.calls,
		user  : state.me.user
	};
};

const mapDispatchToProps = () =>
{
	return {

	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.calls === next.room.calls,
				prev.me.user === next.me.user
			);
		}
	}
)(withStyles(styles)(CallHistory)));
